module.exports = __webpack_public_path__ + "img/Bidvest Bank.d29cd2fb.svg";